import { useState } from "react";
import { Button } from "styles/elements";
import { FlexRow } from "styles/layout";
import { WarningText } from "styles/text";
import { ConfirmSpinner, InitialButton } from "./styles";

interface Props {
  buttonText: string;
  confirmWarning: string;
  confirmFunction: () => Promise<void>;
}
export const ConfirmButton = ({
  buttonText,
  confirmWarning,
  confirmFunction,
}: Props) => {
  const [controlsDisabled, setControlsDisabled] = useState<boolean>(false);
  const [confirmActive, setConfirmActive] = useState<boolean>(false);

  const onInitialClick = async () => {
    setControlsDisabled(true);
    await new Promise(() =>
      setTimeout(() => {
        setConfirmActive(true);
        setControlsDisabled(false);
      }, 2000)
    );
  };

  const onCancel = () => {
    setConfirmActive(false);
  };

  const onConfirm = async () => {
    setControlsDisabled(true);
    await confirmFunction().finally(() => {
      setControlsDisabled(false);
      setConfirmActive(false);
    });
  };

  if (confirmActive) {
    return (
      <FlexRow style={{ columnGap: "5px" }}>
        <WarningText>{confirmWarning}</WarningText>
        <Button onClick={onConfirm} disabled={controlsDisabled}>
          Yes
        </Button>
        <Button onClick={onCancel} disabled={controlsDisabled}>
          Cancel
        </Button>
        {controlsDisabled && <ConfirmSpinner />}
      </FlexRow>
    );
  }

  return (
    <InitialButton onClick={onInitialClick} disabled={controlsDisabled}>
      {controlsDisabled ? <ConfirmSpinner /> : <>{buttonText}</>}
    </InitialButton>
  );
};
